import algoliasearch from 'algoliasearch/lite';

// This is the Search-only API key
const searchClient = algoliasearch(
  'H6MWLDHTG5',
  '45fc58ab091520ba879eb8952b422c4e'
);

export default searchClient;
